/*** live 新版直播  ***/
import { http } from '@/api/http';

// 直播地址需要用线上的
//const LIVE_URL = 'https://api2.anjianba.cn'
const LIVE_URL = ''

export default {
    getMyLiveRooms(data) {
        return http.get(`${LIVE_URL}/api/live2/room/Mine`, data);
    },
    queryLiveRooms(data) {
        return http.get(`${LIVE_URL}/api/live2/room/Query`, data);
    },
    addLiveRoom(data) {
        return http.post(`${LIVE_URL}/api/live2/room/Create`, data, { contentType: 'form' });
    },
    editLiveRoom(id, data) {
        return http.put(`${LIVE_URL}/api/live2/room/${id}`, data, { contentType: 'form' });
    },
    deleteLiveRoom(id) {
        return http.delete(`${LIVE_URL}/api/live2/room/${id}`);
    },

    // the topic which is not empty
    getLiveTopicListUsed(data) {
        return http.get(`${LIVE_URL}/api/live2/room/GetTopicsList`, data);
    },
    // all topic
    getLiveTopic(data) {
        return http.get(`${LIVE_URL}/api/live2/room/BytopicsName`, data);
    },

    getLiveRoomInfo(id) {
        return http.get(`${LIVE_URL}/api/live2/room/${id}`)
    },

    getLiveRoomReport(id) {
        return http.get(`${LIVE_URL}/api/live2/room/Report/${id}`);
    },
    getLiveRoomCurrentOnline(id) {
        return http.get(`${LIVE_URL}/api/live2/room/CurrentOnline/${id}`, {noShowError: true});
    },

    // 签到数据
    getLiveRoomSign(id) {
        return http.get(`${LIVE_URL}/api/live2/room/Sign/${id}`);
    },
    getLiveRoomSignDetail(id, signId) {
        return http.get(`${LIVE_URL}/api/live2/room/SignId/${id}/${signId}`);
    },

    // 直播回放
    getLiveRoomReplay(id) {
        return http.get(`${LIVE_URL}/api/live2/room/Record/${id}`);
    },
    getLiveRoomReplayUrl(id, data) {
        return http.get(`${LIVE_URL}/api/live2/room/RecordUrl/${id}`, data);
    },
    setLiveRoomReplay(id, data) {
        return http.put(`${LIVE_URL}/api/live2/room/RecordDefault/${id}`, data, { contentType: 'form' });
    },

    changePwd(id, data) {
        return http.put(`${LIVE_URL}/api/live2/room/Pwd/${id}`, data, { contentType: 'form' });
    },

    getLiveStartUrl(id) {
        return http.get(`${LIVE_URL}/api/live2/room/StartUrl/${id}`);
    },
    getLiveViewUrl(id, data) {
        return http.get(`${LIVE_URL}/api/live2/room/ViewUrl/${id}`, data);
    },

}
